import {Component} from "@angular/core";
import {DialogComponent} from "../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../store";


@Component({
    selector: 'db-change-email-success',
    templateUrl: 'change-email-success.component.html',
    styleUrls: ['change-email-success.component.scss'],
    standalone: false
})
export class ChangeEmailSuccessComponent extends DialogComponent<null, boolean> {

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
    super(
      _dialogService
    );

  }

  public closeDialog(): void {
    this._store.dispatch(new fromStore.LoadUser());
    this.close();
  }


}
